import { AxiosRequestConfig } from 'axios';
import { BaseReq } from 'bff/models/base/baseReq';
import { BaseRes } from 'bff/models/base/baseRes';
import { InfoI18nResp } from 'bff/models/info/infoI18n';
import { SysOptions } from 'bff/models/info/sysoptions';
import apiService from 'bff/services/apiService';
import { ApplicationId } from 'constants/enums/applicationId.enum';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { call, put, takeEvery } from 'redux-saga/effects';
import { actionTypes } from 'redux/actions';
import { addLocaleAction, setAvailOptionsAction, setLanguageAction } from 'redux/actions/resources.action';
import storageService from 'utils/storageService';

const baseReq: BaseReq<any> = {
  MWHEADER: {
    // ApplicationId: ApplicationId.FrontEnd
  },
  TRANRQ: {

  }
};

const reqConfig: AxiosRequestConfig = {
  headers: {
    ApplicationId: ApplicationId.FrontEnd
  }
};

function * fetchResources () {
  const sysArgs = {
    ...baseReq,
    TRANRQ: {
      PCLASS: ['I18N']
    }
  };
  let lng = ['zh'];
  // 取得可用語系
  const response: BaseRes<SysOptions> = yield call(apiService.fetchSysOptions, sysArgs, reqConfig);
  if (response && response.TRANRS && response.TRANRS.I18N) {
    lng = response.TRANRS.I18N.map(it => it.PARAM_VALUE);
    yield put(setAvailOptionsAction(response.TRANRS.I18N.map(it => ({ value: it.PARAM_VALUE, text: it.PARAM_TEXT }))));
  }
  for (const it of lng) {
    const lngArgs = {
      ...baseReq,
      TRANRQ: { LOCALE: it }
    };
    // 取得指定語系資料
    const response: BaseRes<InfoI18nResp> = yield call(apiService.fetchI18n, lngArgs, reqConfig);
    if (response && response.TRANRS) {
      const data: {[key: string]: string} = {};
      if (response.TRANRS.DATA) {
        response.TRANRS.DATA.forEach(it => {
          data[it.TID] = it.RES_TEXT;
        });
        yield put(addLocaleAction({
          lng: response.TRANRS.LOCALE,
          data: data
        }));
      }
    }
  }
  const lngSaved = storageService.getItem(storageKeys.Lng);
  if (lngSaved) {
    yield put(setLanguageAction(lngSaved));
  }
}

export function * watchResources () {
  yield takeEvery(actionTypes.RESOURCES.FETCH_RESOURCES, fetchResources);
};
